'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Footer = require('./common/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _reactRouterDom = require('react-router-dom');

var _Api = require('../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _StyleGenerator = require('../utils/StyleGenerator');

var _StyleGenerator2 = _interopRequireDefault(_StyleGenerator);

var _MainStore = require('../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _ScheduleScreenStore = require('../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _SpinButton = require('./generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Spinner = require('./generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//wrapper functional component to pass params as props to main file.
function withLocationRouter(Component) {
    function ComponentWithLocationReactRouter(props) {
        // const navigate = useNavigate();
        var history = (0, _reactRouterDom.useHistory)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history /* other hooks */ }));
    }
    return ComponentWithLocationReactRouter;
}

var SelectLocation = function (_React$Component) {
    _inherits(SelectLocation, _React$Component);

    function SelectLocation(props) {
        _classCallCheck(this, SelectLocation);

        var _this = _possibleConstructorReturn(this, (SelectLocation.__proto__ || Object.getPrototypeOf(SelectLocation)).call(this, props));

        _this.state = {
            isNavExpanded: false,
            LocationDetail: null,
            BusinessDetail: {},
            BusinessLocations: [],
            searchTerm: "",
            isLocationMobileView: false,
            isLocationTabView: false,
            showSpinner: true,
            isMobile: false,
            isBrowser: false
        };

        _this.loadGMap = _this.loadGMap.bind(_this);
        _this.renderAllLocation = _this.renderAllLocation.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.renderWebView = _this.renderWebView.bind(_this);
        _this.renderMobileView = _this.renderMobileView.bind(_this);
        _this.loadLocationContent = _this.loadLocationContent.bind(_this);
        _this.loadSpinner = _this.loadSpinner.bind(_this);
        _this.renderNotFoundComp = _this.renderNotFoundComp.bind(_this);
        _this.renderFooter = _this.renderFooter.bind(_this);
        _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
        return _this;
    }

    _createClass(SelectLocation, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setState({
                compUpdate: true
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var self = this;
            var width = window.innerWidth;
            var mobView = width < 993 ? true : false;
            //only apply class on div.
            var browserView = width < 1200 ? true : false;

            _Api2.default.getAllLocations().then(function (responseData) {
                if (responseData.data) {
                    self.setState({
                        BusinessDetail: responseData.data.BusinessDetail,
                        BusinessLocations: responseData.data.BusinessLocations,
                        showSpinner: false,
                        isMobile: mobView,
                        isBrowser: browserView
                    }, function () {
                        self.renderBusinessBasedOnLocations();
                        // load the css config
                        if (!Utils.isEmptyObj(self.state.BusinessDetail)) {
                            _StyleGenerator2.default.generateGlobalStyleSheet(self.state.BusinessDetail.websiteConfig);
                        }

                        _ScheduleScreenStore2.default.resetScheduleDate();
                        if (!self.state.isMobile) {
                            _this2.loadGMap();
                        }
                    });
                } else {
                    self.setState({
                        BusinessDetail: {},
                        BusinessLocations: [],
                        showSpinner: true,
                        isMobile: mobView,
                        isBrowser: browserView
                    });
                    console.log("Mapping not present");
                }
            },
            // error case
            function (errorResponse) {
                // console.log("Error while fetching business locations !");
                if (errorResponse && errorResponse.responseJSON) {
                    console.log(errorResponse.responseJSON.error.message);
                }
            });

            //add resize browser window listener
            window.addEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //remove resize browser window listener
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {

            var width = window.innerWidth;

            this.setState({
                isMobile: width < 993 ? true : false,
                isBrowser: width < 1200 ? true : false
            });
        }
    }, {
        key: 'renderBusinessBasedOnLocations',
        value: function renderBusinessBasedOnLocations() {
            var self = this;
            var locations = self.state.BusinessLocations;
            var businessSupportMultiLocations = self.doesBusinessSupportMultiLocation(locations);

            if (!businessSupportMultiLocations) {
                var loc = locations[0];

                if (!Utils.isEmptyObj(loc)) {
                    var locId = loc.objectId;
                    this.props.history.push("/location/" + locId);
                }
            }
        }
    }, {
        key: 'doesBusinessSupportMultiLocation',
        value: function doesBusinessSupportMultiLocation(locations) {
            var businessSupportMultiLocations = false;

            if (locations.length > 1) {
                businessSupportMultiLocations = true;
            }

            return businessSupportMultiLocations;
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            this.setState({
                searchTerm: e.target.value
            });
        }
    }, {
        key: 'loadGMap',
        value: function loadGMap() {

            var businessLocations = this.state.BusinessLocations;
            var bLocation = this.state.BusinessLocations[0];

            var locations = [];

            businessLocations.forEach(function (loc, index) {
                var locOrder = index + 1;
                var arr = [loc.name, loc.location.latitude, loc.location.longitude, locOrder.toString()];
                locations.push(arr);
            });

            var map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: 8,
                center: new google.maps.LatLng(bLocation.location.latitude, bLocation.location.longitude),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            var infowindow = new google.maps.InfoWindow();

            var marker, i;

            for (i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                    map: map,
                    label: {
                        text: locations[i][3],
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "bold"
                    },
                    visible: true
                });

                google.maps.event.addListener(marker, 'click', function (marker, i) {
                    return function () {
                        infowindow.setContent(locations[i][0]);
                        infowindow.open(map, marker);
                    };
                }(marker, i));
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(locId) {
            var history = this.props.history;
            // Navigate to Another Component

            history.push("/location/" + locId);
        }
    }, {
        key: 'getAddressStrFromLocData',
        value: function getAddressStrFromLocData(data) {
            var address = "";
            var addLineStr = "";

            if (data != null) {
                if (data.addLine1) {
                    addLineStr = data.addLine1;
                }

                if (data.addLine2) {
                    addLineStr = addLineStr + ' ' + data.addLine2;
                }

                address = addLineStr + ',\n            \n ' + data.city + ', ' + data.state + '  ' + data.zipCode;
            }
            return address;
        }
    }, {
        key: 'showTodayOpenHours',
        value: function showTodayOpenHours(locData) {

            var openHours = locData.openHours;
            var dateTime = _MainStore2.default.getCurrentDateTime(locData.timeZone);

            var weeklyOpenHours = Utils.getOpenHoursString(openHours, dateTime);

            var currentDay = Utils.getCurrentDayShort(dateTime).toUpperCase();

            var dailyOpenHours = weeklyOpenHours[currentDay];

            var dailyOpenKey = void 0;

            var rowData = "";
            if (dailyOpenHours) {
                for (dailyOpenKey in dailyOpenHours) {
                    var dailyOpenKeyValue = dailyOpenHours[dailyOpenKey];

                    if (dailyOpenKeyValue && dailyOpenKeyValue != "CLOSED") {
                        var startTime = dailyOpenHours[dailyOpenKey][0];
                        var endTime = dailyOpenHours[dailyOpenKey][1];

                        var sprater = dailyOpenKey != 0 ? " | " : "";

                        var startEndTime = sprater + startTime + " - " + endTime;
                        rowData += startEndTime;
                    } else {
                        rowData += dailyOpenKeyValue;
                    }
                }
            }

            return _react2.default.createElement(
                'span',
                null,
                'Today ',
                rowData
            );
        }
    }, {
        key: 'renderAllLocation',
        value: function renderAllLocation() {
            var _this3 = this;

            var businessLocations = this.state.BusinessLocations;
            var isMobile = this.state.isMobile;
            var searchTerm = this.state.searchTerm;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                businessLocations.filter(function (val) {

                    if (searchTerm == "") {
                        return val;
                    } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.addLine1.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.addLine2.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.city.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.state.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.zipCode.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return val;
                    } else if (val.phoneNumber.includes(searchTerm)) {
                        return val;
                    } else {
                        document.getElementById("alert-box").style.display = "block";
                        window.scrollTo(0, 0);
                    }
                }).map(function (locData, index) {

                    if (!Utils.isEmptyObj(locData)) {
                        var alertBox = document.getElementById("alert-box");
                        if (alertBox) {
                            alertBox.style.display = "none";
                        }
                    }

                    var url = "";

                    //if mediaArray is present set
                    //image url
                    if (locData.hasOwnProperty("mediaArray") && locData.mediaArray.length > 0) {
                        url = locData.mediaArray[0].url;
                    }

                    return _react2.default.createElement(
                        'div',
                        { className: "location-card", key: index },
                        _react2.default.createElement(
                            'div',
                            { className: 'offer-card-horizontal border-0 shadow-sm card-body-box card', key: index, onClick: function onClick() {
                                    _this3.handleClick(locData.objectId);
                                } },
                            _react2.default.createElement(
                                'div',
                                { className: 'd-flex no-gutters row' },
                                !isMobile ? _react2.default.createElement('div', {
                                    className: 'col-sm-12 col-md-5',
                                    style: { backgroundImage: 'url(' + url + ')', backgroundSize: 'cover' }
                                }) : null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12 col-lg-7' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card-body' },
                                        _react2.default.createElement(
                                            'h5',
                                            { className: 'card-title' },
                                            locData.name
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-ico card-text mb-1' },
                                                _react2.default.createElement(
                                                    'i',
                                                    { className: 'icofont-location-pin  ' },
                                                    ' '
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-title card-text px-1 mb-1' },
                                                _this3.getAddressStrFromLocData(locData)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-ico card-text mb-1' },
                                                _react2.default.createElement('i', { className: 'icofont-phone ' })
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-title card-text px-1 mb-1' },
                                                Utils.formatPhoneNumber(locData.phoneNumber)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: "" },
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-ico card-text mb-1' },
                                                _react2.default.createElement('i', { className: 'icofont-wall-clock' })
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'location-card-title card-text px-1 mb-1' },
                                                ' ',
                                                _this3.showTodayOpenHours(locData),
                                                ' '
                                            )
                                        ),
                                        _react2.default.createElement(_SpinButton2.default, {
                                            classNames: 'btn btn-sm btn-styl font-weight-bold mt-1 px-3 pr-3',
                                            buttonText: 'Order Now',
                                            spinText: "Loading...",
                                            showSpinner: false,
                                            whenClicked: function whenClicked() {
                                                _this3.handleClick(locData.objectId);
                                            },
                                            showIcon: true,
                                            iconClass: "icofont-food-cart mr-1",
                                            tabIndex: 2 + index
                                        })
                                    )
                                )
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: 'renderNotFoundComp',
        value: function renderNotFoundComp() {
            return _react2.default.createElement(
                'div',
                { id: "alert-box", style: { display: "none" } },
                _react2.default.createElement(
                    'h4',
                    null,
                    'Looks like we don\'t have any locations in your area.'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Sorry about that. Please enter a different address.'
                )
            );
        }
    }, {
        key: 'renderMobileView',
        value: function renderMobileView() {
            return _react2.default.createElement(
                'section',
                { className: 'section osahan-track-order-page', id: "select-location" },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row d-flex align-items-start' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 mt-3'
                            },
                            _react2.default.createElement(
                                'div',
                                { className: "fixedHeaderLogo w-100" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row bg-white' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-4 mt-2' },
                                        _react2.default.createElement('img', { className: '',
                                            src: this.state.BusinessDetail.logoURL,
                                            alt: 'Location logo',
                                            height: 90,
                                            width: 120
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-8 location-search-input pr-5 mt-2' },
                                        _react2.default.createElement(
                                            'div',
                                            { id: '#menu', className: 'bg-white rounded explore-outlets' },
                                            _react2.default.createElement(
                                                'form',
                                                { className: 'explore-outlets-search mb-3' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'input-group' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        {
                                                            className: "d-inline-block w-100" + " search-loc" + " mb-0"
                                                        },
                                                        this.state.BusinessDetail.name || "",
                                                        _react2.default.createElement('input', {
                                                            type: 'text', placeholder: 'Search for location',
                                                            className: 'form-control mt-2',
                                                            onChange: this.handleSearch
                                                        }),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'input-group-append' },
                                                            _react2.default.createElement('i', { className: 'icofont-search  search__btn' })
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 item-container' },
                            _react2.default.createElement(
                                'div',
                                { className: "mt-3 loc-box" },
                                this.renderAllLocation(),
                                this.renderNotFoundComp()
                            ),
                            this.renderFooter()
                        )
                    )
                )
            );
        }
    }, {
        key: 'loadLocationContent',
        value: function loadLocationContent() {
            var isMobile = this.state.isMobile;
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                isMobile ? this.renderMobileView() : this.renderWebView()
            );
        }
    }, {
        key: 'loadSpinner',
        value: function loadSpinner() {
            return _react2.default.createElement(_Spinner2.default, {
                disply: "block",
                classNames: "spinner-box"
            });
        }
    }, {
        key: 'renderFooter',
        value: function renderFooter() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                Utils.isEmpty(this.state.searchTerm) ? _react2.default.createElement(
                    'div',
                    { id: "locationFooter" },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-12 px-0 pr-0' },
                        _react2.default.createElement(_Footer2.default, null)
                    )
                ) : null
            );
        }
    }, {
        key: 'renderWebView',
        value: function renderWebView() {
            var isBrowser = this.state.isBrowser;

            return _react2.default.createElement(
                'section',
                { className: 'section osahan-track-order-page' },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row d-flex align-items-start' },
                        _react2.default.createElement('div', { className: (isBrowser ? "col-md-5" : "col-md-7") + ' fixed-top pl-0 h-100', 'aria-hidden': 'true', id: "map-canvas", tabIndex: -1 }),
                        _react2.default.createElement(
                            'div',
                            { className: (isBrowser ? "col-md-7 offset-md-5" : "col-md-5" + " offset-md-7") + ' mb-3 vh-100' },
                            _react2.default.createElement(
                                'div',
                                { className: "fixedHeaderLogo w-100" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row bg-white shadow-sm' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-md-4 mt-2' },
                                        _react2.default.createElement('img', { className: '',
                                            src: this.state.BusinessDetail.logoURL,
                                            alt: 'Location logo',
                                            height: 100
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-md-8 mt-3 pr-5' },
                                        _react2.default.createElement(
                                            'div',
                                            { id: '#menu', className: 'bg-white rounded explore-outlets' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'explore-outlets-search mb-3' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'input-group' },
                                                    _react2.default.createElement(
                                                        'label',
                                                        {
                                                            className: "d-inline-block w-100" + " search-loc" + " mb-0"
                                                        },
                                                        this.state.BusinessDetail.name || "",
                                                        _react2.default.createElement('input', {
                                                            type: 'text', placeholder: 'Search for location...',
                                                            className: 'form-control mt-2',
                                                            onChange: this.handleSearch,
                                                            tabIndex: 1
                                                        }),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'input-group-append' },
                                                            _react2.default.createElement('i', { className: 'icofont-search search__btn' })
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: "loc-box" },
                                this.renderAllLocation(),
                                this.renderNotFoundComp()
                            ),
                            this.renderFooter()
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.state.showSpinner ? this.loadSpinner() : this.loadLocationContent()
            );
        }
    }]);

    return SelectLocation;
}(_react2.default.Component);

//create highter order component.


var HOC_LOCATION = withLocationRouter(SelectLocation);

exports.default = HOC_LOCATION;


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectLocation.jsx
// module id = 228
// module chunks = 0